import { IAppState } from '../../redux';
import { ECheckServiceStatus } from '../../redux/reducers';

export function selectCheckServiceStatus(state: IAppState): ECheckServiceStatus {
  return state.checkoutInfo.status;
}
